var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVistaarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "25 30 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2b",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A99FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3F30C9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lineShadow",
    filterUnits: "userSpaceOnUse",
    x: 35,
    y: 80,
    width: 130,
    height: 65,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 1.5,
    floodColor: "#000000",
    floodOpacity: 0.4
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes vistaarLeafFlip {\n      0%, 80%   { transform: rotate(0deg) rotateY(0deg); }\n      82%       { transform: rotate(-6deg) rotateY(0deg); }\n      84%       { transform: rotate(6deg) rotateY(0deg); }\n      86%       { transform: rotate(-6deg) rotateY(0deg); }\n      86.67%    { transform: rotate(0deg) rotateY(0deg); }\n      87.5%     { transform: rotate(-14deg) rotateY(0deg); }\n      88.5%     { transform: rotate(14deg) rotateY(0deg); }\n      89.5%     { transform: rotate(-14deg) rotateY(0deg); }\n      90.5%     { transform: rotate(14deg) rotateY(0deg); }\n      91.5%     { transform: rotate(-10deg) rotateY(0deg); }\n      92.5%     { transform: rotate(10deg) rotateY(0deg); }\n      93.33%    { transform: rotate(0deg) rotateY(0deg); }\n      100%      { transform: rotate(0deg) rotateY(360deg); }\n    }\n    .leaf {\n      transform-box: fill-box;\n      transform-origin: center;\n      animation: vistaarLeafFlip 15s linear infinite;\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "leaf",
    d: "M55 45 C 55 105, 145 105, 145 45 C 145 120, 100 165, 100 165 C 100 165, 55 120, 55 45 Z",
    fill: "url(#g2b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 110 L72 110 L84 85 L100 135 L116 92 L128 110 L155 110",
    filter: "url(#lineShadow)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVistaarLogo);
export default __webpack_public_path__ + "static/media/vistaar-logo.893c9831bd26189951d4a13e6f7fe442.svg";
export { ForwardRef as ReactComponent };